// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-theme="pink"] {
    --primary: #EB69A1;
    &[data-mode="dark"] {
        --background: #21171A;
        --bar-background: #3B292E;
        --color: #F1EFF0;
        --bar-color: #6C6E74;
        --border-color: #787680; 
        --active-border-color: #E6679D;
        --hover-background: #4e2f48;
        --selected-background: #461f30;
        --selected-color: #FFFFFF;
        --drop-background: #3f2c33;
    }
    &[data-mode="light"] {
        --background: #fff;
        --color: #21171A; 
        --bar-background: #edeaec;
        --bar-color: #676D75;
        --border-color: #D2D7DE;
        --active-border-color: #E6679D;
        --hover-background: #f7d1e1;
        --selected-background: #f0a3c4;
        --selected-color: #15181c;
        --drop-background: #eb85b0;
    }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
